import React from "react";
import "../../styles/components/Footer.css";

const Footer = () => {
	return (
		<footer className="footer">
			<div className="footer__text">
				<p>Fan tribute to Berserk and Kentaro Miura.</p>
				<p>
					<a href="https://github.com/KralMarko123/berserk" target="_blank" rel="noreferrer">
						Source code here.
					</a>
				</p>
			</div>
		</footer>
	);
};

export default Footer;
